import React from 'react';
import { motion } from 'framer-motion';
import styled from 'styled-components';
import { Section, Title } from '../styled/StyledComponents';
import { contentVariants } from '../animations/Variants';

const TeamContainer = styled.div`
  max-width: 800px;
  margin: 8rem auto;
  padding: 0 2rem;
  display: flex;
  flex-direction: column;
  align-items: center;

  @media (max-width: 768px) {
    margin: 4rem auto;
  }
`;

const ImageContainer = styled.div`
  width: 100%;
  aspect-ratio: 4/3;
  background-color: #f0f0f0;
  border-radius: 10px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  margin-bottom: 3rem;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;

const Description = styled.div`
  text-align: center;
  color: #666;
  line-height: 1.8;
  font-size: 1.1rem;
  max-width: 600px;
  margin: 0 auto;
  
  p {
    margin-bottom: 1.5rem;
    
    &:last-child {
      margin-bottom: 0;
    }
  }
`;

const EquipeSection: React.FC = () => {
  return (
    <motion.div
      key="equipe"
      initial="enter"
      animate="center"
      exit="exit"
      variants={contentVariants}
    >
      <Section>
        <Title>L'Équipe</Title>
        <TeamContainer>
          <ImageContainer>
            <img src="/assets/images/F+S.JPG" alt="Florence et Sonia" />
          </ImageContainer>
          <Description>
            <p>
              Nous sommes un groupe de psychomotriciennes formées ensemble à Genève, et nous travaillons 
              aujourd'hui dans un même cabinet dédié à l'accompagnement de la petite enfance. Nous accueillons 
              les tout-petits et leurs familles dans un environnement chaleureux, où chaque enfant peut 
              évoluer à son rythme.
            </p>
            <p>
              Ensemble, nous offrons une approche complète et personnalisée pour soutenir le développement 
              des enfants, en prenant en compte leurs besoins corporels, émotionnels et relationnels. 
              Notre collaboration nous permet de combiner nos compétences pour proposer un accompagnement 
              adapté et de qualité, toujours centré sur le bien-être de l'enfant et de sa famille.
            </p>
          </Description>
        </TeamContainer>
      </Section>
    </motion.div>
  );
};

export default EquipeSection;
